import React, { useEffect, useRef } from "react";

// Fixed-size WEBSITE display ad (AdSense). Desktop .io web formats only — no
// mobile/responsive units. Renders a real <ins> when a publisher + display slot
// are configured (live site), otherwise a neutral fixed-size placeholder.
const PUB = process.env.REACT_APP_AD_PUBLISHER_ID || null;
const DISPLAY_SLOT = process.env.REACT_APP_AD_DISPLAY_SLOT || null;

const SIZES = {
  leaderboard: { w: 728, h: 90 },   // classic web banner
  rectangle: { w: 300, h: 250 },    // medium rectangle
  billboard: { w: 970, h: 90 },
};

export function WebAd({ format = "leaderboard", className = "" }) {
  const { w, h } = SIZES[format] || SIZES.leaderboard;
  const pushed = useRef(false);
  const live = !!(PUB && DISPLAY_SLOT);

  useEffect(() => {
    if (live && !pushed.current) {
      pushed.current = true;
      try { (window.adsbygoogle = window.adsbygoogle || []).push({}); } catch (e) { console.warn("web ad push failed", e); }
    }
  }, [live]);

  return (
    <div className={`flex justify-center ${className}`} data-testid={`web-ad-${format}`}>
      <div className="rounded-lg border border-slate-700/50 bg-slate-900/40 overflow-hidden shrink-0" style={{ width: w, maxWidth: "100%", height: h }}>
        {live ? (
          <ins className="adsbygoogle" style={{ display: "inline-block", width: w, height: h }}
            data-ad-client={PUB} data-ad-slot={DISPLAY_SLOT} data-testid="adsense-web-unit" />
        ) : (
          <div className="w-full h-full flex flex-col items-center justify-center text-center">
            <div className="text-[10px] uppercase tracking-[0.2em] text-slate-500 font-bold">Advertisement</div>
            <div className="text-slate-600 text-[10px] mt-0.5">{w} × {h}</div>
          </div>
        )}
      </div>
    </div>
  );
}
